import { getUserAction } from '../Reducks/User/actions';
import { fetchFeatureFlagsAction } from '../Reducks/FeatureFlags/actions';

const newUserLoaded = (action, getState) => (
  action.type === String(getUserAction.fulfilled) && action.payload.metadata && !getState().user.metadata
);

const unleashMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  if (newUserLoaded(action, getState)) {
    const { metadata } = action.payload;
    const context = {
      userKey: String(metadata.userKey || ''),
      email: String(metadata.email || ''),
      channel: String(metadata.channel || ''),
      seats: String(metadata.seats || ''),
      serviceType: String(metadata.serviceType || ''),
      accountKey: String(metadata.accountKey || '')
    };

    dispatch(fetchFeatureFlagsAction(context));
  }

  return next(action);
};

export default unleashMiddleware;
